import React from "react";
import { Logo } from "../../components/Logo";
import { PageFooter } from "../../components/PageFooter";
import "./index.css";

export function ConnectionError() {
  return (
    <div className="connection-error-wrapper">
      {/* メインコンテンツ */}
      <div className="connection-error-content">
        {/* ロゴ */}
        <Logo />

        {/* エラーメッセージ */}
        <div className="error-message">
          <h1 className="error-title">
            Something went wrong.
            <br />
            Please try again later.
          </h1>
        </div>
      </div>

      {/* フッター */}
      <PageFooter className="fixed" />
    </div>
  );
}

